const cardItems = [
  {
    title: '周星驰喜剧全集',
    desc: '重温星爷经典笑料，从《大话西游》到《功夫》，百看不厌的喜剧之王作品合集',
    img: 'https://readdy.ai/api/search-image?query=Classic%20comedy%20film%20scene%20with%20warm%20stage%20lighting%2C%20theatrical%20atmosphere%2C%20red%20velvet%20curtains%2C%20cinematic%20composition%2C%20golden%20spotlight%2C%20entertainment%20show%20vibe&width=600&height=400&seq=card-comedy&orientation=landscape',
    tag: '喜剧',
  },
  {
    title: '悬疑剧烧脑合集',
    desc: '结局绝对猜不到！精选高分悬疑剧，反转不断烧脑体验，让你看到停不下来',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20room%20with%20warm%20desk%20lamp%20and%20scattered%20clues%2C%20detective%20atmosphere%2C%20soft%20shadows%2C%20noir%20film%20aesthetic%2C%20warm%20brown%20tones%2C%20suspenseful%20mood&width=600&height=400&seq=card-thriller&orientation=landscape',
    tag: '悬疑',
  },
  {
    title: '漫威宇宙观影顺序',
    desc: '一份完整的漫威观影指南，按时间线梳理从钢铁侠到最新大作的全部篇章',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20universe%20collage%20with%20warm%20cosmic%20lighting%2C%20hero%20silhouettes%2C%20dramatic%20cloudscape%2C%20golden%20and%20amber%20tones%2C%20blockbuster%20movie%20atmosphere&width=600&height=400&seq=card-marvel&orientation=landscape',
    tag: '科幻',
  },
  {
    title: '韩剧最新追更表',
    desc: '每周更新热门韩剧播出时间表，浪漫爱情、悬疑推理全类型覆盖',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20warm%20autumn%20leaves%20and%20soft%20sunset%20lighting%2C%20couple%20silhouette%2C%20cinematic%20depth%20of%20field%2C%20emotional%20atmosphere%2C%20gentle%20amber%20tones&width=600&height=400&seq=card-kdrama&orientation=landscape',
    tag: '韩剧',
  },
  {
    title: '动漫番剧秋季档',
    desc: '2026秋季新番抢先看，热血、治愈、异世界，你喜欢的题材这里都有',
    img: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20with%20warm%20autumn%20colors%2C%20maple%20leaves%20falling%2C%20soft%20golden%20light%2C%20Japanese%20animation%20art%20style%2C%20dreamy%20atmosphere%2C%20warm%20amber%20and%20orange%20hues&width=600&height=400&seq=card-anime-fall&orientation=landscape',
    tag: '动漫',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          精选专题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">精心策划的影视内容合集</p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-50 transition-colors"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="px-2.5 py-0.5 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700">
                  {item.tag}
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {cardItems.slice(3).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <span className="self-start px-2.5 py-0.5 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700">
                  {item.tag}
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}